import { DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { MockInterceptorEntry, RequestInterceptorEntry, ResponseInterceptorEntry } from '@frontend/fetch';
import { AirDemoMockRouterContext } from './types';

/**
 * @deprecated Use `DemoInterceptorUtils` from `@frontend/demo-interceptors` instead.
 */
export const AnalyticsDemoInterceptorUtils = {
  getApiEndpointForDemoInterceptor: DemoInterceptorUtils.getApiEndpointForDemoInterceptor,
  isMatchingApiEndpoint: DemoInterceptorUtils.isMatchingApiEndpoint,
  getRequestInterceptors: DemoInterceptorUtils.getRequestInterceptors as (
    interceptorRouters: FeatureMockRouter<any>[],
    context: AirDemoMockRouterContext
  ) => RequestInterceptorEntry[],
  getResponseInterceptors: DemoInterceptorUtils.getResponseInterceptors as (
    interceptorRouters: FeatureMockRouter<any>[],
    context: AirDemoMockRouterContext
  ) => ResponseInterceptorEntry[],
  getMockRouter: DemoInterceptorUtils.getMockRouter as (
    interceptorRouters: FeatureMockRouter<any>[],
    context: AirDemoMockRouterContext,
    interceptorIdPrefix: string
  ) => MockInterceptorEntry,
};
